import { IfpEligibilityCheckSteps } from '../typings';

export const UPFRONT_PAYMENT_ID = 'pay_upfront';

export const DEFAULT_ELIGIBILITY_STEPS = [
  {
    id: 0,
    name: 'Account',
    value: IfpEligibilityCheckSteps.AccountSelection,
  },
  { id: 1, name: 'Line', value: IfpEligibilityCheckSteps.LineSelection },
];

export const PLAN_STEP = {
  id: 2,
  name: 'Plan',
  value: IfpEligibilityCheckSteps.PlanSelection,
};

export const REVIEW_STEP = {
  id: 3,
  name: 'Review',
  value: IfpEligibilityCheckSteps.ReviewPlan,
};
